<template>
  <v-container>
    <PageHeader noPadding title="Export All Data Report" icon="poll" />
    <v-progress-linear indeterminate v-if="globalIsLoading"></v-progress-linear>
    <v-alert type="info" :value="(!globalIsLoading) && (reportVisibilityOption.length == 0)">
      There are no report types activated for this tenant.
      Please contact the system administrator to activate reports.
    </v-alert>

    <v-layout row wrap v-if="selectedReport === null && !globalIsLoading">
      <v-flex xs12 md12 v-if="reportTypeIsVisible(reportObjects.allExport.configKey)">
        <v-card>
          <v-card-title class="headline">
            Analytical Data
          </v-card-title>
          <v-card-text class="pt-0">
            All analytical data for selected monitoring component, grouped by station and media type.
            <br />
            <strong>Note:</strong> It may take a few minutes to export all data.
          </v-card-text>
          <v-card-text>
            <v-layout>
              <v-flex sm6 md3>
                <v-select solo v-bind:items="medias" v-model="selectedMedia" label="Select Monitoring Component:" single-line menu-props="bottom" return-object></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn :loading="loading" color="info" @click="downloadGroundWaterReport" :disabled="!selectedMedia.length">
              <v-icon class="mr-1">save_alt</v-icon>
              {{ $t('Button.Download') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-snackbar v-model="snackbar" :top="true" :timeout="snackTimeout" :vertical="true" :color="snackColor">
        {{ snackMessage }}
        <v-btn dark flat @click="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-layout>
    <v-layout row wrap v-if="selectedReport === null">
      <v-flex v-for="card in rReports" :key="card.title">
        <v-card>
          <Subheader color="teal" :title="card.Name" no-search />
          <v-card-media :src="card.PreviewImage" height="200px"></v-card-media>
          <v-card-text>{{card.Description}}</v-card-text>
          <v-card-actions class="white">
            <v-btn color="warning" light @click="selectedReport = card">{{ $t('Button.View') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="selectedReport != null">
      <v-flex md12>
        <v-toolbar color="teal" dark>
          <v-toolbar-title>{{selectedReport.Name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="selectedReport = null" color="warning" light>
            <v-icon>eject</v-icon>
            {{ $t('Button.back') }}
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <iframe v-bind:src="'http://hf-gtvan-envirodata:3838/' + selectedReport.UrlPart" width="100%" height="1024px"></iframe>
        </v-card-text>
        <v-card-actions>
          <v-btn color="warning" light @click="selectedReport = null">{{ $t('Button.back') }}</v-btn>
        </v-card-actions>
      </v-flex>
    </v-layout>
    <WaterQualityReportsErrorModal v-model="errorModal" :data="errorModalData" :loading="errorModalLoading" :customTitle="customTitle" @download="onErrorModalCallback" @cancel="onErrorModalClose" />
    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title" :header="errorDialog.header" />
  </v-container>
</template>

<script>
  import MomentUtil from '@/components/mixins/MomentUtil'
  import DownloadUtil from '@/components/mixins/DownloadUtil'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import ErrorDialog from '@/components/generic/ErrorDialog'
  import ReportsErrorModalUtil from '@/components/mixins/ReportsErrorModalUtil'
  import WaterQualityReportsErrorModal from '@/components/WaterQualityReportsErrorModal'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import {
    UiConfigKeys,
  } from '@/store/UI/uiconfig'
  import {
    reportTypes,
  } from '@/store/stations'

  const app = createNamespacedHelpers('app')
  const stations = createNamespacedHelpers('stations')
  const uiConfig = createNamespacedHelpers('uiconfig')

  export default {
    components: {
      WaterQualityReportsErrorModal,
      ErrorDialog,
    },
    mixins: [MomentUtil, DownloadUtil, SnackBarUtil, ReportsErrorModalUtil],
    props: [],
    data() {
      return {
        items: [],
        rReports: [],
        selectedReport: null,
        selectedMedia: '',
        loading: false,
      }
    },
    computed: {
      ...stations.mapGetters(['stationCategories']),
      ...uiConfig.mapGetters(['uiConfigOptions', 'uiConfigOptionByKey']),
      medias() {
        if (this.stationCategories == null) {
          return []
        }
        return this.stationCategories.map(c => c.Name)
      },
      globalIsLoading() {
        return this.uiConfigOptions.isLoading
      },
      reportObjects() {
        return reportTypes
      },
      reportVisibilityOption() {
        let data = this.uiConfigOptionByKey(
          UiConfigKeys.ReportComponentVisibility
        )
        if (!(data && data.Value)) {
          return []
        }
        return JSON.parse(data.Value)
      },
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    methods: {
      ...uiConfig.mapActions(['getUiConfigOptions']),
      ...app.mapActions(['setSnackbar']),
      async downloadGroundWaterReport({
        suppressErrors,
      }) {
        this.loading = true

        this.setSnackbar({
          icon: 'info',
          color: 'info',
          text: 'The download may take some time to finish. Please do not close your browser until the download is complete.',
        })

        var url = '/Report/ExportAllData/' + this.selectedMedia
        var fileName = this.selectedMedia + '_Lab_Sample_Data.xlsx'
        let params = {
          suppressErrors: suppressErrors || false,
        }
        let options = {
          params: params,
        }

        try {
          await this.download(url, fileName, options)
          this.resetErrorModal()
        } catch (error) {
          if (error.response.status == 204) {
            this.setErrorDialog({
              data: 'Report generation failed because there is no discrete data for monitoring component ' + this.selectedMedia + '. If you expect discrete data for this component, please contact tenant administrator.',
              header: 'No discrete data for selected monitoring component',
              show: true,
            })
          } else {
            let { data, customTitle } = this.generateReportTitleAndData(error.response.data)
            this.setErrorModal(data, () => {
              this.downloadGroundWaterReport({
                suppressErrors: true,
              })
            }, customTitle)
          }
        } finally {
          this.loading = false
        }
      },
      reportTypeIsVisible(reportTypeConfigKey) {
        return this.reportVisibilityOption.includes(reportTypeConfigKey)
      },
      fetchUiConfigOptions() {
        let options = {
          config: {},
          forced: false,
          successCb: () => {},
          failedCb: (msg) => {
            console.error(msg)
            this.$store.dispatch('app/setErrorDialog', {
              data: `failed to fetch report visibility options: ${msg}`,
              title: msg.message,
              show: true,
            })
          },
        }

        this.getUiConfigOptions(options)
      },
    },
    mounted() {
      this.fetchUiConfigOptions()
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  .v-progress-circular {
    margin-left: 1rem;
  }
</style>